import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["lightBtn", "darkBtn", "systemBtn"]

  connect() {
    this.applyTheme()
    
    // Listen for system theme changes
    this.mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    // Store the bound handler — removeEventListener with a fresh .bind()
    // removes nothing, leaking a change listener per connect cycle.
    this.systemChangeHandler = this.handleSystemChange.bind(this)
    this.mediaQuery.addEventListener('change', this.systemChangeHandler)
    
    // Update button states
    this.updateButtonStates()
  }

  disconnect() {
    if (this.mediaQuery && this.systemChangeHandler) {
      this.mediaQuery.removeEventListener('change', this.systemChangeHandler)
    }
  }

  toggle() {
    const isDark = document.documentElement.classList.contains('dark')
    if (isDark) {
      localStorage.setItem('theme', 'light')
    } else {
      localStorage.setItem('theme', 'dark')
    }
    this.applyTheme()
    this.updateButtonStates()
  }

  setLight() {
    localStorage.setItem('theme', 'light')
    this.applyTheme()
    this.updateButtonStates()
  }

  setDark() {
    localStorage.setItem('theme', 'dark')
    this.applyTheme()
    this.updateButtonStates()
  }

  setSystem() {
    localStorage.removeItem('theme')
    this.applyTheme()
    this.updateButtonStates()
  }

  applyTheme() {
    const theme = localStorage.getItem('theme')
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    
    if (theme === 'dark' || (!theme && prefersDark)) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }

  handleSystemChange() {
    // Only respond to system changes if we're in system mode
    if (!localStorage.getItem('theme')) {
      this.applyTheme()
    }
  }

  updateButtonStates() {
    if (!this.hasLightBtnTarget) return
    
    const theme = localStorage.getItem('theme')
    
    // Active styles
    const activeClasses = ['bg-white', 'dark:bg-gray-700', 'shadow-sm', 'text-gray-900', 'dark:text-white']
    const inactiveClasses = ['text-gray-500', 'dark:text-gray-400', 'hover:text-gray-700', 'dark:hover:text-gray-300']
    
    // Reset all buttons
    const allButtons = [this.lightBtnTarget, this.darkBtnTarget, this.systemBtnTarget]
    allButtons.forEach(btn => {
      activeClasses.forEach(cls => btn.classList.remove(cls))
      inactiveClasses.forEach(cls => btn.classList.add(cls))
    })
    
    // Set active button
    let activeBtn
    if (theme === 'light') {
      activeBtn = this.lightBtnTarget
    } else if (theme === 'dark') {
      activeBtn = this.darkBtnTarget
    } else {
      activeBtn = this.systemBtnTarget
    }
    
    inactiveClasses.forEach(cls => activeBtn.classList.remove(cls))
    activeClasses.forEach(cls => activeBtn.classList.add(cls))
  }
}
